import React, { ReactNode } from "react"
import { Box, Center } from "@chakra-ui/react"
import ConfettiBoom from "react-confetti-boom"

type Props = {
  children: ReactNode
}

const ConfettiExplosion = ({ children }: Props) => (
  <>
    {/* Bright blurred overlay behind confetti; non-interactive so modal remains usable */}
    <Box position="fixed" inset={0} pointerEvents="none" zIndex={1200}>
      <Box
        position="absolute"
        inset={0}
        bg="rgba(210,210,210,0.18)"
        backdropFilter="blur(14px)"
        filter="none"
        boxShadow="none"
      />
    </Box>

    {/* Put confetti in a full-screen fixed layer so it covers more area reliably */}
    <Box position="fixed" inset={0} pointerEvents="none" zIndex={1250}>
      <ConfettiBoom
        mode="boom"
        x={0.5}
        y={0.35}
        particleCount={650}
        shapeSize={10}
        spreadDeg={300}
        colors={[
          "#FF2D55", // hot pink
          "#FF9500", // orange
          "#FFCC00", // yellow
          "#34C759", // green
          "#00C7FF", // cyan
          "#007AFF", // blue
          "#5856D6", // indigo
          "#AF52DE", // purple
        ]}
        // Keep the celebration visible a bit longer.
        opacityDeltaMultiplier={0.45}
        effectInterval={6500}
      />
    </Box>

    <Center>{children}</Center>
  </>
)

export default ConfettiExplosion
